export const userListColumns = [
  { key: "user_name", label: "이름" },
  { key: "phone_number", label: "전화번호" },
  { key: "mobile_carrier", label: "통신사" },
  { key: "resident_number", label: "주민등록번호" },
  { key: "address", label: "주소" },
];
